export const de = {
  toast: {
    error: {
      offlineModuleModelNotSaveable: "Offline-Speichern nicht erlaubt",
    },
    success: {},
    warning: {},
  },
};
